module.exports = __webpack_public_path__ + "static/media/IMG_4287.9ac0ada5.PNG";